import { render, staticRenderFns } from "./golf.vue?vue&type=template&id=0f741c21&scoped=true&"
import script from "./golf.vue?vue&type=script&lang=js&"
export * from "./golf.vue?vue&type=script&lang=js&"
import style0 from "./golf.vue?vue&type=style&index=0&id=0f741c21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f741c21",
  null
  
)

export default component.exports